<template>
  <div class="h-full" :id="id">
    <WidgetsContainer :horizontal-padding="false" :loading="false">
      <template #body>
        <div v-show="loading" class="flex h-full items-center justify-center">
          <BaseLoader class="justify-center" />
        </div>
        <div v-show="!loading" :id="containerId" class="tradingview-widget-container">
          <div class="tradingview-widget-container__widget"></div>
        </div>
      </template>
    </WidgetsContainer>
  </div>
</template>
<script setup>
import { ref, computed, onMounted, watch, inject } from 'vue';

//INJECTS
const id = inject('id');
const widget = inject('widget');

const SCRIPT_ID = 'tradingview-economic-calendar-widget-script';
const RANDOM_ID = Math.random();
const loading = ref(false);
const scriptId = computed(() => {
  return SCRIPT_ID + RANDOM_ID;
});
const containerId = computed(() => {
  return 'tradingview-widget-container-' + RANDOM_ID;
});
const attributes = computed(() => {
  return `{
      "width": "100%",
      "height": "100%",
      "colorTheme": "dark",
      "isTransparent": true,
      "locale": "en",
      "importanceFilter": "-1,0,1",
      "currencyFilter": "${widget.value.configuration?.currenciesSelected?.join(',')}"
    }`;
});

function canUseDOM() {
  return typeof window !== 'undefined' && window.document && window.document.createElement;
}
function getScriptElement() {
  return document.getElementById(scriptId.value);
}
function scriptExists() {
  return getScriptElement() !== null;
}
function appendScript() {
  if (!canUseDOM()) {
    return;
  }
  if (scriptExists()) {
    return;
  }
  const script = document.createElement('script');
  script.id = scriptId.value;
  script.type = 'text/javascript';
  script.async = true;
  script.innerHTML = attributes.value;
  script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-events.js';
  script.onload = () => {
    loading.value = false;
  };
  document.getElementById(containerId.value).appendChild(script);
}

watch(widget, () => {
  document.getElementById(scriptId.value).remove();
  appendScript();
});
onMounted(() => {
  appendScript();
});
</script>
